// extracted by mini-css-extract-plugin
export default {"donut":"styles_donut__GUw6j"};